module.exports = __webpack_public_path__ + "img/illu-dna.973963ab.svg";